import { productListingReducer as productListing } from '../../../features/commerce/product-listing/product-listing-slice.js';
import { fetchMoreProducts, fetchProductListing, promoteChildToParent, } from './product-listing-actions.js';
/**
 * Loads the commerce product listing reducer and returns the available product listing action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the product listing action creators.
 *
 * @group Actions
 * @category ProductListing
 */
export function loadProductListingActions(engine) {
    engine.addReducers({ productListing });
    return {
        fetchProductListing,
        fetchMoreProducts,
        promoteChildToParent,
    };
}
